import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GoalsDataDisclaimer from "../GoalsDataDisclaimer";

export default function RegionalPerformanceCard({
  rank,
  regionPercent,
  nationalAvgPercent,
  noGoalsDataAvailable = false,
  goalsDataDisclaimerShow = false,
}) {
  const ordinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
  };

  const Tile = ({ value, label, tooltipText = "" }) => (
    <Box
      sx={{
        bgcolor: "#F6F9FB",
        borderRadius: 2,
        px: "5px",
        py: 4,
        textAlign: "center",
      }}
    >
      <Typography sx={{ fontSize: 24, fontWeight: 700, lineHeight: 1 }}>
        {value}%
      </Typography>
      <Stack
        direction="row"
        mx="auto"
        alignItems="center"
        textAlign="center"
        justifyContent="center"
        spacing={0.5}
      >
        <Typography sx={{ mt: 1, fontSize: 14, color: "#4A5568" }}>
          {label}
        </Typography>
        <Tooltip
          title={tooltipText}
          placement="bottom"
          slotProps={{
            popper: {
              modifiers: [{ name: "offset", options: { offset: [0, -10] } }],
            },
            tooltip: {
              sx: {
                bgcolor: "#FFFFFF",
                color: "#2D2D2D",
                border: "1px solid #E6E6E6",
                boxShadow: "0px 1px 2px 0px #0000000D",
              },
            },
          }}
        >
          <Box
            aria-label="Information of the Tooltip"
            sx={{ lineHeight: 0, display: "inline-flex" }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 15, color: "#A0A0A0" }} />
          </Box>
        </Tooltip>
      </Stack>
    </Box>
  );

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "8px",
        border: "0.5px solid #F0F0F0",
        boxShadow: "1px 4px 4px 0px #00000008",
        height: "100%",
      }}
    >
      <CardContent sx={{ py: "24px", px: "16px" }}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600, mb: 4, fontSize: 14, lineHeight: 1.2 }}
        >
          Region Performance (Current Quarter)
        </Typography>

        {goalsDataDisclaimerShow && <GoalsDataDisclaimer />}

        <>
          <Box
            sx={{
              bgcolor: "#F6F9FB",
              borderRadius: 2,
              px: 3,
              py: 6,
              textAlign: "center",
              mb: 2,
            }}
          >
            {noGoalsDataAvailable ? (
              <Typography
                sx={{ fontSize: 14, color: "#666666", fontWeight: 500 }}
              >
                Stay tuned - New Goals for current Quarter to be available soon
              </Typography>
            ) : (
              <>
                <Typography
                  sx={{ mb: 1, fontSize: 24, fontWeight: 700, lineHeight: 1 }}
                >
                  {ordinal(rank)}
                </Typography>
                <Stack
                  direction="row"
                  mx="auto"
                  alignItems="center"
                  textAlign="center"
                  justifyContent="center"
                  spacing={0.5}
                >
                  <Typography sx={{ fontSize: 14, color: "#4A5568" }}>
                    Region Rank by % to goal
                  </Typography>
                  <Tooltip
                    title="The relative rank of your region by progress-to-goal value as of today for the current quarter."
                    placement="bottom"
                    slotProps={{
                      popper: {
                        modifiers: [
                          { name: "offset", options: { offset: [0, -10] } },
                        ],
                      },
                      tooltip: {
                        sx: {
                          bgcolor: "#FFFFFF",
                          color: "#2D2D2D",
                          border: "1px solid #E6E6E6",
                          boxShadow: "0px 1px 2px 0px #0000000D",
                        },
                      },
                    }}
                  >
                    <Box
                      aria-label="Info about region rank"
                      sx={{ lineHeight: 0, display: "inline-flex" }}
                    >
                      <InfoOutlinedIcon
                        sx={{ fontSize: 15, color: "#A0A0A0" }}
                      />
                    </Box>
                  </Tooltip>
                </Stack>
              </>
            )}
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Tile
                value={regionPercent}
                label="Targets Reached: Region"
                tooltipText="Percentage of total target HCPs reached by the Sales Reps in the region as of today."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Tile
                value={nationalAvgPercent}
                label="Targets Reached: National Average"
                tooltipText="Aggregate percentage of total target HCPs reached by the Sales Reps across all regions as of today."
              />
            </Grid>
          </Grid>
        </>
      </CardContent>
    </Card>
  );
}
